import {MetaTitleDesc} from "../meta";
import DocumentMeta from "react-document-meta";

export default () => {
    const title = 'Паровоз Л1259';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    <p>Типа 1-5-0 серии Л №1259</p>
                    <p>Построен в 1949 году на Брянском паровозостроительном заводе</p>
                    <p>Расчетный вес паровоза с тендером 170т</p>
                    <p>Нагрузка на ось - 18,2т</p>
                    <p>Конструктивная скорость - 80 км/ч</p>
                    <p>Предельное рабочее давление пара в котле - 14кг/см2</p>
                    <p>Брянский паровозостроительный завод (затем - Брянский машиностроительный завод), один из крупнейших заводов транспортного машиностроения СССР. Основан в 1873 как металлургический завод по производству железнодорожных рельсов и скреплений. В 80-х гг. 19 в. выпускал вагоны, платформы и цистерны, а в 90-х гг. - паровозы. В период Гражданской войны и военной интервенции 1918-20 рабочие завода ремонтировали бронепоезда, паровозы, вагоны, выполняли заказы для фронта. За годы довоенных пятилеток завод реконструирован и расширен. Во время немецко-фашистской оккупации г. Брянска завод был разрушен. После освобождения города (сентябрь 1943) завод восстановлен, построены новые цехи: турбинный, дизельный и др. В декабре 1946 изготовлен первый послевоенный паровоз серии Л мощностью 1470 квт.С 1946 завод выпускает вагоны, с 1951 вместо паровозов - паровые турбины. В 1954 выпущен первый паротурбинный энергопоезд мощностью 4000 квт. В 1958 начат выпуск маневровых тепловозов, в 1961 выпущен первый судовой дизель мощностью 6624 квт.</p>
                </div>
                <div className="three-col-cell gallery"><img src={require('./../img/virtualtours/museumlocomotive/mzt044.jpg')} /></div>
                <div className="three-col-cell gallery"><img src={require('./../img/virtualtours/museumlocomotive/mzt045.jpg')} /></div>
            </div>
        </>
    );
}